import { useContext, useSyncExternalStore } from 'react';
import { SMLEditorContext } from '../SMLEditorContext';
import { EditorSavesSnapshot, EditorSaveTracker } from './editorSaveTracker';

/** The save tracker of the editor, or null outside the editor (a form in a test). */
export function useEditorSaves(): EditorSaveTracker | null {
  return useContext(SMLEditorContext)?.saves ?? null;
}

const IDLE: EditorSavesSnapshot = { isBusy: false, hasUndoWaiting: false, invalidCount: 0 };
const idle = (): EditorSavesSnapshot => IDLE;
const noSubscribe = (): (() => void) => () => undefined;

/** The busy state of the tracker for React (see `EditorSavesSnapshot`). */
export function useEditorSavesState(tracker: EditorSaveTracker | null): EditorSavesSnapshot {
  return useSyncExternalStore(tracker?.subscribe ?? noSubscribe, tracker?.getSnapshot ?? idle);
}
